<script setup lang="ts">
import { useProductPageStore } from "~/stores/main";
import { useMeilisearch } from "~/utils/meilisearch";

const hideProperties = [
  "masterproduct_dont_degroup_at_order_property",
  "masterproduct_created_property",
  "product_szin_property",
  "product_paletta_property",
  "product_meret_property",
];

// -----------------------
// composables
// -----------------------
const config = useRuntimeConfig();
const store = useProductPageStore();
const { t } = useI18n();

// -----------------------
// computed properties
// -----------------------
const propertiesRef = computed(() => {
  const properties: Record<string, string> = {};

  if (Array.isArray(allProperties) && allProperties.length) {
    for (const property of allProperties) {
      if (
        store.masterProduct &&
        property.index_code in store.masterProduct &&
        !hideProperties.includes(property.index_code)
      ) {
        const label = property.name;
        const value = String(store.masterProduct[property.index_code]);
        properties[label] = value
          .replace(/^\|+|\|+$/g, "")
          .replace(/\|/g, ", ");
      }
    }
  }

  return properties;
});

const hasAttributes = computed(() => {
  return Object.keys(propertiesRef).length > 0;
});

const allProperties = await useMeilisearch(
  config.public.meilisearchIndexProperties,
  { limit: 200 },
);
</script>

<template>
  <div
    v-if="hasAttributes"
    class="col-span-full px-2.5 mb-[40px] text-brand-headline"
  >
    <h2
      class="font-bold font-lora !text-2xl lg:!text-30 text-center h-[60px] !leading-[60px] !mt-0"
    >
      {{ t("technical_details") }}
    </h2>

    <div
      class="w-full mt-9 text-16 grid grid-cols-[auto_1fr] leading-[36px] lg:leading-[34px]"
    >
      <template v-for="(value, label) in propertiesRef" :key="label">
        <div class="font-bold pr-[40px]">
          {{ label }}
        </div>
        <div>
          {{ value }}
        </div>
      </template>
    </div>
  </div>
</template>
